import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router';

import type { ArticleSummary } from '@/content/articles';
import { ArticleArtwork } from './ArticleArtwork';
import { formatArticleDate } from './formatArticleDate';

export function ArticleCard({ article }: { article: ArticleSummary }) {
  return (
    <article className="article-card group">
      <Link to={`/blog/${article.slug}`} className="article-card-link">
        <ArticleArtwork article={article} className="article-card-art" />
        <div className="mt-6 flex items-center gap-3 text-xs font-medium text-ink-500">
          <span className="text-ember-700">{article.category}</span>
          <span aria-hidden="true">·</span>
          <span>{article.readingTime} min read</span>
        </div>
        <h3 className="mt-3 text-[1.35rem] font-medium leading-snug tracking-[-.025em] text-ink-900 transition-colors group-hover:text-ember-700">
          {article.title}
        </h3>
        <p className="mb-6 mt-3 text-sm leading-6 text-ink-500">
          {article.description}
        </p>
        <div className="mt-auto flex items-center justify-between border-t border-hairline pt-4 text-xs text-ink-500">
          <time dateTime={article.publishedAt}>
            {formatArticleDate(article.publishedAt)}
          </time>
          <span className="flex items-center gap-1.5 font-medium text-ink-700">
            Read article{' '}
            <ArrowUpRight className="size-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </span>
        </div>
      </Link>
    </article>
  );
}
